import { theme } from "@tm/utility/global";
import styled from "styled-components";
import { deviceType } from "../../../../utils";

export const ContactFormSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding-bottom: 24px;
  max-height: calc(100vh - 200px);
  overflow-y: auto;
  overflow-x: hidden;

  @media ${deviceType.mobile} {
    max-height: calc(100vh - 180px);
    padding: 16px 0;
  }
`;

export const ContactFormFields = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const ModalFooter = styled.div`
  position: sticky;
  bottom: 0;
  background: ${theme.whiteText};
  padding: 0;
  margin: auto -30px 0 -30px;
  border-top: 1px solid ${theme.lightSilver};
  display: flex;
  flex-direction: column;
  z-index: 10;

  @media ${deviceType.mobile} {
    margin: auto -30px 0 -30px;
  }
`;

export const FooterButtonRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 30px;
  gap: 12px;

  @media ${deviceType.mobile} {
    flex-direction: column-reverse;
    padding: 16px;
  }
`;

export const FooterLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const FooterRight = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

interface SaveButtonProps {
  hasChanges?: boolean;
  isLoading?: boolean;
}

export const SaveButton = styled.button<SaveButtonProps>`
  padding: 12px 32px;
  background: ${(props) => {
    if (props.isLoading) return theme.blueText;
    if (props.hasChanges) return theme.blueText;
    return theme.greyText2;
  }};
  color: ${theme.whiteText};
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 700;
  cursor: ${(props) =>
    props.hasChanges && !props.isLoading ? "pointer" : "not-allowed"};
  transition: all 0.2s;
  min-width: 140px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  &:hover {
    background: ${(props) => {
      if (props.isLoading || !props.hasChanges)
        return props.hasChanges ? theme.blueText : theme.greyText2;
      return theme.prussianBlue;
    }};
  }

  &:disabled {
    background: ${theme.greyText2};
    cursor: not-allowed;
  }

  @media ${deviceType.mobile} {
    width: 100%;
    padding: 14px 32px;
  }
`;

export const ModalSubtitle = styled.p`
  margin: 0;
  font-size: 14px;
  line-height: 20px;
  color: ${theme.greyText};
  font-weight: 400;
`;
